import * as React from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import Modal from "react-modal";

library.add(faTimes);

interface IProps extends React.Props<ImageCropModal> {
    imageUrl: string;
    isOpen: boolean;
    onRequestClose: () => void;
    onSubmitCrop: (x: number, y: number, w: number, h: number, croppedBlobUrl: string) => void;
    targetHeight: number;
    targetWidth: number;
}

interface IState {
    isLoading: boolean;
}

export default class ImageCropModal extends React.Component<IProps, IState> {
    private cropper: Cropper;
    private imageBox: HTMLImageElement;

    public constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: true,
        };
    }

    public render() {
        if (!this.props.isOpen) {
            return null;
        }

        return <Modal
            ariaHideApp={false}
            className={"ReactModal__Content ReactModal__Content--after-open ReactModal__Content"}
            isOpen={this.props.isOpen}
            overlayClassName={"ReactModal__Overlay ReactModal__Overlay--after-open ReactModal__Overlay CMS_PF_dialog CMS_PF_react CMS_react_ScrollingDialog nr-img-crop-modal-overlay"}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            onAfterOpen={this.initCropper}
            onRequestClose={() => this.props.onRequestClose()}
        >
            <a
                className="CMS_dialogClose CMS_button CMS_bSquare CMS_bCancel"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    this.props.onRequestClose();
                }}
            >
                <FontAwesomeIcon icon="times" />
                <span className="offScreen">Close</span>
            </a>

            <this.modalContents/>
        </Modal>;
    }

    private modalContents = () => {
        return (
            <>
                <div className="CMS_element nr-img-crop-modal">
                    <div className="CMS_title CMS_T4">
                        <em className="fa fa-image"></em> { }
                        Add Image
                    </div>

                    <div className="nr-img-crop-container">
                        <img src={this.props.imageUrl}
                            style={{ display: "block", maxWidth: "100%" }}
                            ref={(ref) => this.imageBox = ref}
                            crossOrigin="anonymous" />
                    </div>

                    <this.footerButtons />
                </div>
            </>
        );
    }

    private footerButtons = () => {
        return (
            <div className="CMS_buttonGroup CMS_bg-R">
                <a
                    className="CMS_button CMS_bAction"
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        const data = this.cropper.getData();
                        this.cropper.getCroppedCanvas().toBlob((blob) => {
                            const croppedUrl = URL.createObjectURL(blob);
                            this.props.onSubmitCrop(
                                Math.round(data.x),
                                Math.round(data.y),
                                Math.round(data.width),
                                Math.round(data.height),
                                croppedUrl);
                        });
                    }}
                >
                    Add
                </a>
              &nbsp;

                <a
                    className="CMS_button CMS_bCancel"
                    href="#"
                    onClick={(e) => {
                    e.preventDefault();
                    this.props.onRequestClose();
                    }}
                >
                    Close
                </a>
            </div>
        );
    }

    private initCropper = () => {
        this.cropper = new Cropper(this.imageBox, {
            aspectRatio: this.props.targetWidth / this.props.targetHeight,
            cropBoxResizable: true,
            guides: false,
            imageSmoothingQuality: "high",
            viewMode: 1,
        } as any);
        this.setState({isLoading: false});
    }
}
